import { useEffect } from 'react';

import { Button, Form, RyeconClose, Sizes, useZodForm } from '@dbt-labs/sourdough';

import { useDbtCloudAccount } from '@/context/DbtCloudProvider';
import { useFilterContext, zNodeFilters } from '@/context/FilterProvider';
import { usePanel } from '@/context/PanelProvider';
import { useCurrentPage } from '../Page';
import { AdvancedFilters } from './AdvancedFilters';
import { EnvironmentTypeFilters } from './EnvironmentTypeFilters';
import {
  ModelAccessFilters,
  ModelingLayerFilters,
  ModelMaterializationFilters,
} from './ModelLevelFilters';
import { MultiProjectFilter } from './MultiProjectFilters';
import { PlatformFilters } from './PlatformFilters';
import { TagFilters, tagsName } from './TagFilters';
import { TypeFilters } from './TypeFilters';
import { useAccountFilterPanel } from './useAccountFilterPanel';
import { WarehouseTypeFilters } from './WarehouseTypeFilters';

export const AccountFilterPanel = () => {
  const { hasAccountFeature } = useDbtCloudAccount();
  const hasCatalog = hasAccountFeature('catalogIngestion');
  const filterContext = useFilterContext();

  const panel = usePanel();

  const { dbtIsActive, warehouseIsActive } = useAccountFilterPanel();

  const { currentPage } = useCurrentPage();
  const isProjectLineage = currentPage === 'projectLineage';

  // @ts-ignore
  const formMethods = useZodForm(zNodeFilters);
  const tagsFilter = filterContext.filters[tagsName];
  useEffect(() => {
    formMethods.setValue(
      tagsName,
      (tagsFilter ?? []).map((tag) => ({ label: tag, value: tag })),
    );
  }, [tagsFilter, formMethods]);

  return (
    <>
      {/* TODO: This is a weird hack since the Form component has a span that is limiting the height. */}
      <style>{`
      form {
        height: 100%;
      }
    `}</style>
      <Form formMethods={formMethods} onSubmit={() => {}}>
        <div
          data-testid="filter-panel"
          className="h-full w-[265px] border-r border-borderMuted bg-bgMain text-fgMain"
        >
          <span className="flex-0 flex space-x-1">
            {isProjectLineage && (
              <Button
                type="icon-button"
                size={Sizes.sm}
                ryecon={RyeconClose}
                className="flex-1 p-1 align-middle"
                ariaLabel="Close"
                tooltip="Close"
                onClick={() => {
                  panel.toggleFilterPanel(false);
                }}
              />
            )}
          </span>
          <div className="m-6 pb-24 text-base">
            {hasCatalog && <PlatformFilters />}
            {dbtIsActive && <MultiProjectFilter formMethods={formMethods} />}
            {dbtIsActive && <EnvironmentTypeFilters />}
            {dbtIsActive && <TypeFilters title="dbt Asset type" onDive={undefined} />}
            {dbtIsActive && <TagFilters />}
            <AdvancedFilters title="Properties" />
            {dbtIsActive && <ModelingLayerFilters title="Modeling layer" />}
            {warehouseIsActive && <WarehouseTypeFilters />}
            {dbtIsActive && <ModelAccessFilters title="Model access" />}
            {dbtIsActive && <ModelMaterializationFilters title="dbt Materialization" />}
          </div>
        </div>
      </Form>
    </>
  );
};
